export const cashStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'info'];
  if (status === 9) {
    type = 'warning';
  } else {
    type = types[status - 1];
  }
  return type;
}

export const authStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success'];
  if (status === 9) {
    type = 'danger';
  } else {
    type = types[status];
  }
  return type;
}

export const CheckStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'warning'];
  if (status === 999) {
    type = 'danger';
  } else {
    type = types[status];
  }
  return type;
}

export const organizationStatusType = (status) => {
  let type = '', types = ['', 'primary', 'success', 'danger'];
  if (status === 9) {
    type = 'warning';
  } else {
    type = types[status];
  }
  return type;
}

